/**
 * @param {string} string
 * @returns {string}
 */
function domFriendlyString (string) {
  if (!string) return ''

  return string
    ?.toString()
    ?.toLowerCase()
    ?.replace(/å/g, 'a')
    ?.replace(/ä/g, 'a')
    ?.replace(/æ/g, 'a')
    ?.replace(/ö/g, 'o')
    ?.replace(/ø/g, 'o')
    ?.replace(/\s/g, '-')
    ?.replace(/[^a-z0-9-]/g, '')
}

module.exports = { domFriendlyString }
